import { Component } from '@angular/core';
import { NavController, LoadingController } from 'ionic-angular';
import { HttpClient } from '@angular/common/http';
import { Globals } from '../../../../globals';
import { ConfigurationServices } from '../../services';
import { StarPRNT } from '@ionic-native/star-prnt';
import { PrintServices } from '../../../services/printServices';


@Component({
  selector: 'page-configuration-printers-starprnt',
  templateUrl: 'configuration-printers-starprnt.html'
})

export class ConfigurationPrintersStarprntPage {

  checkStatus: any;
  starprnt_cashdrawer: boolean;

  constructor(public navCtrl: NavController,
    public globals: Globals,
    public http: HttpClient,
    public loadingCtrl: LoadingController,
    private configurationServices: ConfigurationServices,
    private starprnt: StarPRNT,
    public printServices: PrintServices) {
    //
    if (this.globals.restaurant.printer_type == 'starprnt') {
      this.checkStatus = null;
      this.check();
      this.starprnt_cashdrawer = this.globals.restaurant.starprnt_cashdrawer;
    }
  }

  check() {
    this.starprnt.checkStatus(this.globals.restaurant.starprnt_portName, 'StarPRNT')
      .then((res: any) => {
        this.checkStatus = res;
      })
      .catch((error: any) => { });
  }

  reload() {
    this.checkStatus = null;
    this.check();
  }

  mPOPOpenPrint() {
    this.printServices.testStarPrntPrint(this.globals.restaurant.starprnt_portName);
  }

  mPOPOpenCashDrawer() {
    this.printServices.openCashDrawerSP();
  }

  async updateIonToggle(starprnt_cashdrawer) {
    this.globals.restaurant.starprnt_cashdrawer = starprnt_cashdrawer;
    this.configurationServices.afs.collection('restaurants').doc(this.globals.restaurant_uid).update({
      'starprnt_cashdrawer': starprnt_cashdrawer,
    });
  }

}



// WEBPACK FOOTER //
// ./src/pages/configuration/configuration-thermal-printers/configuration-printers-starprnt/configuration-printers-starprnt.ts